import { useQuery, UseQueryOptions } from 'react-query';
import { BranchesService } from '../../services';
import { IBranchDetail } from '../../interfaces';

export const useBranchById = (id?: string, options?: UseQueryOptions<IBranchDetail, Error, IBranchDetail, [string, string]>) => {
  return useQuery<IBranchDetail, Error, IBranchDetail, [string, string]>(
    ['branch', id || ''],
    async ({ queryKey }) => {
      const [, branchId] = queryKey;
      const result = await BranchesService.getById(branchId);
      if (result.status === 200) return result.data;
      throw new Error(result.data as string);
    },
    // `cacheTime: 0` so reopening an edited branch never seeds Formik from a stale row.
    { cacheTime: 0, ...options },
  );
};
